import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = { class: "text-truncate" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.data.name ?? ''}`,
    id: `${_ctx.viewName}`,
    showClose: !_ctx.loading,
    showDialog: _ctx.showDialog,
    "height-class": [_ctx.tableData.length <= 5 ? 'h-400px' : ''],
    "width-class": "width-900 mw-900px py-0",
    "modal-class": "view-site-detail-modal",
    onModalClose: _ctx.closeModal
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.t("common.close")), 9, _hoisted_6)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Datatable, {
        "card-class": "h-auto",
        "card-header": false,
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        total: _ctx.total,
        rowsPerPage: _ctx.rowsPerPage,
        page: _ctx.page,
        loading: _ctx.loading,
        showSearch: _ctx.showSearch,
        viewName: "formDocuments",
        onQueryUpdate: _ctx.queryUpdate
      }, {
        "cell-documentName": _withCtx(({ row: document }) => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(document.documentName), 1)
        ]),
        "cell-siteName": _withCtx(({ row: document }) => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(document.siteName), 1)
        ]),
        "cell-userName": _withCtx(({ row: document }) => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(document.userName), 1)
        ]),
        "cell-startDate": _withCtx(({ row: document }) => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.format.DateTime(_ctx.format.convertToLocalTimeZone(document.startDate))), 1)
        ]),
        "cell-endDate": _withCtx(({ row: document }) => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.format.DateTime(_ctx.format.convertToLocalTimeZone(document.endDate))), 1)
        ]),
        "cell-status": _withCtx(({ row: document }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text-truncate fw-bolder", {
            'badge badge-success bg-success':
              document.scheduleStatus === 'ON_TIME' || 'OUTSIDE_PERIOD',
            'badge badge-danger bg-danger':
              document.scheduleStatus === 'EXPIRED',
          }])
          }, _toDisplayString(document.scheduleStatus === "ON_TIME"
              ? "Completed"
              : document.scheduleStatus === "OUTSIDE_PERIOD"
              ? "Completed"
              : _ctx.format.TitleCase(document.scheduleStatus?.toLowerCase())), 3)
        ]),
        _: 1
      }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "onQueryUpdate"])
    ]),
    _: 1
  }, 8, ["title", "id", "showClose", "showDialog", "height-class", "onModalClose"]))
}